import type {
  QueryParams,
  QueryRecommendationsResult,
} from "src/types/adapters/query.type";
import type { PropsWithConstructorClient } from ".";
import type { SearchAdapterOptions } from "src/types/adapters/search.type";

type QueryRecommendationsProps = PropsWithConstructorClient<{
  options: SearchAdapterOptions;
  params: QueryParams;
}>;

// TODO: Implement Recommendations!
// eslint-disable-next-line @typescript-eslint/require-await
export async function queryRecommendations({
  client,
}: QueryRecommendationsProps): Promise<QueryRecommendationsResult> {
  try {
    return {
      totalProductsResult: 0,
      products: [],
    };
  } catch (error) {
    console.error(
      "[Constructor Adapter] An error occurred while fetching query recommendations results:",
      error
    );

    return {
      totalProductsResult: 0,
      products: [],
    };
  }
}
